import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import i18n from "../Components/i18n";
const AddScoring = (props) => {
  const { t } = useTranslation();
  const { onClose, open, timeEditData, setTimeArr } = props;
  const [time, setTime] = useState({
    toh: "",
    tom: "",
    fromh: "",
    fromm: "",
  });
  const [switchButt, setSwitchButt] = useState(false);
 

const [userDay, setUserDay] = useState({});
  const handleClose = () => {
    setTime({
      toh: "",
      tom: "",
      fromh: "",
      fromm: "",
    });
    setSwitchButt(false);
    setUserDay({});
    onClose();
  };
  const formatTime = (time) => {
    const padZero = (num) => (num < 10 ? `0${num}` : num);

    const parseAndClamp = (value, min, max) => {
      const parsed = parseInt(value) || 0;
      return Math.max(min, Math.min(max, parsed));
    };

    const fromh = parseAndClamp(time.fromh, 0, 23);
    const fromm = parseAndClamp(time.fromm, 0, 59);
    const toh = parseAndClamp(time.toh, 0, 23);
    const tom = parseAndClamp(time.tom, 0, 59);

    return `${padZero(fromh)}:${padZero(fromm)}T${padZero(toh)}:${padZero(
      tom
    )}`;
  };

 useEffect(() => {
  if (timeEditData?.time) {
    const [from, to] = timeEditData?.time?.split("T");
    const [fromh, fromm] = from.split(":");
    const [toh, tom] = to.split(":");

    setTime({ fromh, fromm, toh, tom });
    setSwitchButt(timeEditData?.status);

    // FIX: Build entire object before setting state
    const dayObj = {};
    timeEditData?.days?.forEach((el) => {
      dayObj[String(el)] = true;
    });
    setUserDay(dayObj); // Set once
  }
}, [timeEditData]);


  const saveForm = async () => {
    const timekey = formatTime(time);
    const days = Object.keys(userDay).map(Number);
    const newTimeEntry = {
      time: timekey,
      days,
      status: switchButt,
    };

    if (timeEditData?.time) {
      setTimeArr((prevTimeArr) =>
        prevTimeArr.map((el) =>
          el.time === timeEditData.time ? newTimeEntry : el
        )
      );
    } else {
      setTimeArr((prevTimeArr) => [...prevTimeArr, newTimeEntry]);
    }

    handleClose();
  };

  return (
    <div className={`dialog-container ${open ? "open" : ""}`}>
      <div className="dialog">
        <div className="dialog-header">
          <button className="close-btn" onClick={handleClose}>
            <svg
              width="26"
              height="26"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.43 0.244723C10.1145 -0.0707873 9.60485 -0.0707873 9.28934 0.244723L5.33333 4.19264L1.37732 0.236633C1.06181 -0.0788775 0.552143 -0.0788775 0.236633 0.236633C-0.0788775 0.552143 -0.0788775 1.06181 0.236633 1.37732L4.19264 5.33333L0.236633 9.28934C-0.0788775 9.60485 -0.0788775 10.1145 0.236633 10.43C0.552143 10.7455 1.06181 10.7455 1.37732 10.43L5.33333 6.47402L9.28934 10.43C9.60485 10.7455 10.1145 10.7455 10.43 10.43C10.7455 10.1145 10.7455 9.60485 10.43 9.28934L6.47402 5.33333L10.43 1.37732C10.7375 1.0699 10.7375 0.552143 10.43 0.244723Z"
                fill="#707EAE"
              />
            </svg>
          </button>
        </div>
        <div className="dialog-body">
          <div className="form">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <h3>Time</h3>
              <label>
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={switchButt}
                    onChange={(e) => {
                      setSwitchButt(!switchButt);
                    }}
                    name="loading"
                  />
                  <span className="slider"></span>
                </label>
              </label>
            </div>

            <div className="time-input">
              <input
                type="number"
                placeholder="HH"
                value={time.fromh}
                onChange={(e) => {
                  setTime((prev) => ({
                    ...prev,
                    fromh: e.target.value,
                  }));
                }}
                max="12"
                min="00"
                className="input-field"
              />
              <input
                type="number"
                placeholder="MM"
                value={time.fromm}
                onChange={(e) => {
                  setTime((prev) => ({
                    ...prev,
                    fromm: e.target.value,
                  }));
                }}
                max="59"
                min="00"
                className="input-field"
              />
              <span>to</span>
              <input
                type="number"
                placeholder="HH"
                value={time.toh}
                onChange={(e) => {
                  setTime((prev) => ({ ...prev, toh: e.target.value }));
                }}
                max="12"
                min="00"
                className="input-field"
              />
              <input
                type="number"
                placeholder="MM"
                value={time.tom}
                onChange={(e) => {
                  setTime((prev) => ({ ...prev, tom: e.target.value }));
                }}
                max="59"
                min="00"
                className="input-field"
              />
            </div>

        <div className="days-selector">
  {(i18n.language === "he"
    ? [t("S2"), t("F"), t("T2"), t("W"), t("T"), t("M"), t("S")] // Hebrew: Saturday to Friday
    : [t("S"), t("M"), t("T"), t("W"), t("T2"), t("F"), t("S2")] // English: Sunday to Saturday
  ).map((el, index) => {
    const actualIndex =
      i18n.language === "he"
        ? [6, 5, 4, 3, 2, 1, 0][index]
        : index;

    const isSelected = Boolean(userDay[actualIndex]);

    return (
      <div
        key={index}
        onClick={() => {
          setUserDay((prev) => {
            const newDay = { ...prev };
            if (newDay[actualIndex]) {
              delete newDay[actualIndex];
            } else {
              newDay[actualIndex] = true;
            }
            return newDay;
          });
        }}
        style={{
          width: "100px",
          height: "50px",
          borderRadius: "50%",
          backgroundColor: isSelected ? "#E1B84B" : "#FFFFFF",
          cursor: "pointer",
          border: "2px solid",
          borderColor: isSelected ? "#fff" : "#E1B84B",
          justifyContent: "center",
          textAlign: "center",
          display: "flex",
          alignItems: "center",
        }}
      >
        {el}
      </div>
    );
  })}
</div>



            <div className="actions">
              <button
                onClick={() => {
                  handleClose();
                }}
                className="cancel-btn"
              >
               {t("Cancel")} 
              </button>
              <button onClick={saveForm} className="save-btn">
                {t("Save")} 
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddScoring;
